import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LegalStatusEnum } from '../../../../../models/enums/legal-status.enum';
import {
  BaryButtonComponent,
  BaryCardComponent,
  BaryInputSelectComponent,
  BaryInputTextComponent,
  BarySiretComponent
} from '../../../components';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { User } from '../../../../../models/user.model';
import { CardsModule } from 'ng-uikit-pro-standard';

@Component({
  selector: 'jhi-association-card',
  standalone: true,
  imports: [BaryButtonComponent, BaryInputSelectComponent, BaryCardComponent, TranslateModule, BaryInputTextComponent, NgIf, BarySiretComponent, CardsModule],
  templateUrl: './association-card.component.html',
})
export class AssociationCardComponent {
  @Input() baryForm!: FormGroup;
  @Input() editable = true;
  @Input() user?: User;
  @Input() switchButton = false;
  @Input() description?: string;
  @Output() saveEvent = new EventEmitter();

  public legalStatusOptions = [
    {
      label: 'Aucun',
      value: undefined,
    },
    {
      label: 'Association',
      value: LegalStatusEnum.ASSOCIATION,
    },
  ];

  public get addressForm(): FormGroup {
    return this.baryForm.get('addressForm') as FormGroup;
  }

  public get associationForm(): FormGroup {
    return this.baryForm.get('associationForm') as FormGroup;
  }

  public getAssociationControl(name: string): FormControl {
    return this.associationForm.get(name) as FormControl;
  }
}
